var App = App || {};

App.Login = (function ($) {
    "use strict";

    function Init() {
        $(function () {
            const $form = $("#ob-login");

            $form.on("submit", function (e) {
                e.preventDefault();
                e.stopPropagation();

                if (!$form.attr("action")) {
                    return;
                }

                const getValue = id => $(`#${id}`).val().trim();
                const addHiddenInput = (name, value) => {
                    $("<input>", {
                        type: "hidden",
                        name,
                        value: encodeURIComponent(value)
                    }).appendTo($form);
                };

                addHiddenInput("UserName", getValue("txtOLBPopupUsername"));
                addHiddenInput("Password", getValue("txtOLBPopupPassword"));

                this.submit();
            });
        });
    }

    return {
        Init: Init
    };
})(jQuery);